<template>
    <div class="right_wrapper">
		  <!-- <div class="">
			  <div><h3>{{isEditPage ? 'Edit ' : 'Add '}}Template</h3></div>
		  </div> -->
		  <CommonHeader class="main_head_block">
			<template v-slot:header>
			<span class="module_heading">{{isEditPage ? 'Edit ' : 'Add '}}Template</span>
			</template>
		</CommonHeader>
		  <div class="spinner-border" v-if = "isLoading" 
      		style="margin: auto; display: block; margin-top: 60px"></div>
		  <div class="table_wrap no_footer pt-2" v-else>
			  <form v-on:submit.prevent class="main_form_block">

				  <div class = "form-group row" style = "margin: 0px;padding: 0px;">
					  <div style = "border:1px #0000002e solid; padding:20px;" class = "col-md-9">

						  <div class="form-group row">
							  <label class="col-sm-2 col-form-label">
								  Default
							  </label>
							  <div class="col-sm-9 pr-5" style = "display: flex;align-items: center;">
								  <div>
									  <input
										  type="checkbox"
										  v-model="defaultVal"
										  value="true"
										  style="padding-bottom:5px"
										  id="exampleCheck1"
										  autocomplete="off"
									  >
								  </div>
							  </div>
						  </div>

						  <div class="form-group row">
							  <label class="col-sm-2 col-form-label">
								  Title
							  </label>
							  <div class="col-sm-9 pr-5">
								  <input
									  v-on:keydown.enter.prevent
									  type="text"
									  name="entityId"
									  v-model="title"
									  class="form-control"
									  id="temp_title"
									  placeholder="Enter title"
									  :class="{ 'is-invalid': submitted && (!title || title == '')}"
								  >
								  <span
									  v-if="submitted && (!title || title == '') "
									  class="invalid-feedback"
								  >This field is required</span>
							  </div>
						  </div>

						  <div class="form-group row">
							  <label class="col-sm-2 col-form-label">
								  Type
							  </label>
							  <div class="col-sm-9 pr-5">
								  <multiselect
									  v-model="type"
									  :options="type_list"
									  :searchable="true"
									  ref="multiselect"
									  open-direction="bottom"
									  label="type"
									  track-by="type"
									  @select = "getTemplateList"
									  selectLabel
									  deselectLabel
									  selectedLabel
									  class="form-control multi-dropdown col-md-12 select_filter"
									  :multiple="false"
									  id="tags_list_data"
										  >
								  </multiselect>
							  </div>
						  </div>
							  <TemplateBuilder
								ref = "template_builder"
								v-if = "isLoadTemplate"
								:tokensList = "tokensList"
								:type = "type"
								:editorData = "editorData"
							  />
							  <div class = "form-group row">
								  <div class = "col-sm-2"></div>
								  <span
									  class = "col-sm-3 no-data-style"
									  v-if="submitted && editorData == '' || editorData == '<p>Please create your template using the instructions located on the right panel</p>\n'"
								  >This field is required</span>
							  </div>

							  <div class="spinner-border" v-if = "isGettingTemplateData" style = "margin-left:50%"></div>


					  </div>

					  <div style = "max-height:100%;position: fixed;right: 0;top: 20;" class = "col-md-3">

						  <p style = "padding:10px 10px 10px 10px;margin:0px;font-weight:bold;background-color:#17a2b8;color:white">How to use template TOKEN</p>

						  <div style = "background-color:rgb(246, 248, 247);overflow:scroll;height:500px">

							  <p style = "font-size: 12px;line-height: 14pt;padding:20px;margin:0px">Start by naming your template and selecting the type (Campaign Group, Campaign, Keyword, Product, or Profile).</p>

							  <ol style = "padding-bottom:20px;font-size:12px">

								  <li><p style = "font-size: 12px;line-height: 14pt;">Add a table by selecting a table from the “Custom” dropdown </p></li>

								  <img class = "style-img-notes" src="@/assets/images/custom-dropdown.png"/>

								  <li><p style = "font-size: 12px;line-height: 14pt;">You can add or delete columns from the table</p></li>

								  <li><p style = "font-size: 12px;line-height: 14pt;">To add a new column, right click on an existing column and insert the new column before and after. </p></li>

								  <img class = "style-img-notes" src="@/assets/images/insertCol.png"/>

								  <li><p style = "font-size: 12px;line-height: 14pt;">After adding a new column you should always provide a title to the column</p></li>

								  <li><p style = "font-size: 12px;line-height: 14pt;">To include dynamic values select from Token dropdown</p></li>

								  <img class = "style-img-notes" src="@/assets/images/dropdown.png"/>

								  <li><p style = "font-size: 12px;line-height: 14pt;">To delete right click on the column and delete it</p></li>

								  <img class = "style-img-notes" src="@/assets/images/deleteCol.png"/>
							  </ol>
						  </div>

						  </div>
			  </div>


				  <div class = "text-center" style = "padding-top:30px;padding-bottom:20px;" >
					  <button class="btn btn-secondary" @click="navigateToListPage('cancel')">Cancel</button>
					  <button
					  	  v-if = "type"
						  class="btn btn-primary"
						  @click="saveTemplate()"
					  >Save</button>
				  </div>

			  </form>
		  </div>

    
    <!-- Modal Starts -->
    </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import { templateURl } from '@/properties';
import {campaignTable} from './templates/campaignTable.js';
import {productTable} from './templates/productTable.js';
import TemplateBuilder from './TemplateBuilder.vue';

import CommonHeader from "@/components/CommonHeader.vue"


export default {
	name: "AddEditTemplate",
	components:{moment, Multiselect, TemplateBuilder, isLoadTemplate : () => import('./TemplateBuilder.vue'), CommonHeader},
	data(){
		return{
			isLoadTemplate:false,
			isGettingTemplateData:false,
			campaignTable:campaignTable,
			productTable:productTable,
			templateURl:templateURl,
			type_list:[],
			type:null,
			title:"",
			isLoading:false,
			isEditPage:false,
			templateId:'',
			editorData: '',
			submitted:false,
			defaultVal:false
		}
	},
	watch:{
		isEditPage() {
			if (this.isEditPage) {
				this.getDetail()
			}
		},
	},
	beforeMount(){
	},
	mounted(){

		//$('#datetimepicker').datetimepicker();
	//	this.editorConfig.strinsert_strings = this.tokenList
		//this.editorConfig.custom_tables[0].tables[0].table = this.campaignTable
		this.checkIsEdit();
		this.getTypeList()
	},
	computed:{
		tokenList:{
			get() {
				return this.$store.state.template.tokenList;
			}
		}

	},
	methods:{
		navigateToListPage(data){
			if (data == "cancel") {
				this.$store.state.calledFromCancel = true;
			}
			this.$router.push({
				path: "/template"
			});
		},
		saveTemplate(){

			this.editorData = this.$refs['template_builder'].editorDataToEdit;

			let dynamicData = this.editorData.match(/{{(.*?)}}/g);

			let list = this.tokensList.map((e) => {
				return e.tokens
			}).reduce((acc, val) => {
				return acc.concat(val)
			}, [])


			let vm = this;
			let dataToAdd = null;

				if(dynamicData && dynamicData.length){
					dataToAdd = dynamicData.map((e) => {
					let actualVal = list.find((val) => e == val.value)
					let obj = {}
					if(actualVal){
						if(actualVal.label.includes('.')){
							let a = actualVal.label.split('.');
							obj.data = a[1];
							obj.type = 'direct';
							obj.accessTable = actualVal.table_name;
							obj.key = actualVal.key;
						}
						else{
							obj.data = actualVal.label;
							obj.type = 'table';
							obj.accessTable = actualVal.table_name;
							obj.key = actualVal.key;
						}
					}
					return obj
				})
				}


			this.submitted = true
			if(this.validate()){
				let payload = {
					id:this.templateId,
					title:this.title,
					template:this.editorData,
					type:this.type.type,
					dynamic_val:dataToAdd,
					defaultVal:this.defaultVal
				}

				this.isLoading = true;
				let vm = this;
				this.$store.dispatch("template/saveTemplate", payload).then((res) => {
					vm.isLoading = false
					vm.navigateToListPage()
				})
			}


		},

		checkIsEdit(){
			let id = this.$route.params.id;
			if(id){
				this.templateId = id;
				this.isEditPage = true;
			}
			else{
				this.isEditPage = false;
			}
		},
		ckEditorReadyCallback(readyEvent){
		},
		getDetail(){

			let payload = {
				id:this.templateId
			}
			let vm = this;
			this.isLoading = true
			this.$store.dispatch("template/getTemplate", payload).then((res) => {
				vm.title = res.title;
				let typeObj = {type: res.type}
				vm.type = typeObj
				vm.isLoading = false
				this.getTemplateList(typeObj);
				vm.editorData = res.template;
			})
		},
		saveSnapshot(){

		},
		getTypeList(){
			let vm = this;
			this.$store.dispatch("template/getTypeList").then((res) => {
				vm.type_list = res;
			})
		},
		getTemplateList(data){
			// if(this.isLoadTemplate){
			// 	this.$el.parentNode.removeChild(this.$el);
			// }
			this.isLoadTemplate = false

			let payload = {
				type:data.type
			}
			let vm = this;
			this.isGettingTemplateData = true;
			this.editorData = ''

			this.$store.dispatch("template/getTokensList", payload).then((res) => {

				//this.editorConfig.strinsert_strings = res
				vm.tokensList = res
				vm.isGettingTemplateData = false
				vm.isLoadTemplate = true

			})
		},
		validate(){

			if((!this.title || this.title == '') || (!this.type || this.type == null) || this.editorData == '' || this.editorData == '<p>Please create your template using the instructions located on the right panel</p>\n'){
				return false
			}
			else{
				return true
			}
		}
	}
}
</script>

<style lang="scss">

.cke_show_borders {
	border : 0px !important;	
}

	.style-img-notes{
		padding-bottom:20px;
		width:250px
	}


</style>
